import { createPageDefinition } from 'ui-page-helpers/src/createPageDefinition';
import Component from './component';

export default createPageDefinition({
  component: Component,
  title: 'Landing Pages/Gift Code Redemption',
  exportTitle: 'giftCodeRedemption',
  selectorClass: 'gift-code-redemption',
})